module.exports = __webpack_public_path__ + "media/images/athletes/3870-b50b8b9843e17496d3128e1db914053d.png";